export function buildWorkflowStepExchangeId(sourceSteps = [], targetSteps = []) {
  if (!sourceSteps.length || !targetSteps.length) {
    return {};
  }

  const defaultTargetStepId = targetSteps[0]?.workflow_step_id || "";

  return sourceSteps.reduce((accumulator, step) => {
    accumulator[step.workflow_step_id] = defaultTargetStepId;
    return accumulator;
  }, {});
}

export function sortWorkflowSteps(steps = []) {
  return [...steps].sort(
    (left, right) => (left?.step_sequence ?? 0) - (right?.step_sequence ?? 0)
  );
}

export function getSourceBoardOptions(boards = []) {
  return [...boards]
    .filter((board) => !board?.is_archive)
    .sort((left, right) => left.board_name.localeCompare(right.board_name));
}

export function getActiveSourceBoard({
  sourceBoardOptions = [],
  activeSourceBoardId,
  currentBoard = null,
}) {
  return (
    sourceBoardOptions.find((board) => board.board_id === activeSourceBoardId) ??
    currentBoard ??
    null
  );
}

export function getTargetBoardOptions(sourceBoardOptions = [], activeSourceBoardId) {
  return sourceBoardOptions.filter(
    (board) => board.board_id !== activeSourceBoardId
  );
}

export function getWorkflowStepsByWorkflowId(workflowOptions = [], workflowId) {
  return sortWorkflowSteps(
    workflowOptions.find((workflow) => workflow.workflow_id === workflowId)?.steps || []
  );
}
